import Vue from 'vue';
import App from './pages/app-root.vue';
import store from './store';
import router from './router';

// axios
import axios from 'axios';
Vue.prototype.$http = axios;
///
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
//
import { PaginationPlugin } from 'bootstrap-vue';
Vue.use(PaginationPlugin);
///
var VueTruncate = require('vue-truncate-filter');
Vue.use(VueTruncate);
//
import VueMatchHeights from 'vue-match-heights';
Vue.use(VueMatchHeights);
//
import vuePersianFilters from 'vue-persian-filters';
Vue.use(vuePersianFilters);
///
import AjaxPlugin from './plugins/ajax';
Vue.use(AjaxPlugin);
///
var VueCookie = require('vue-cookie');
Vue.use(VueCookie);
///
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
//
//import ScrollLoader from 'vue-scroll-loader'
//Vue.use(ScrollLoader)
//// Vuex Store
//import store from './store/index'

Vue.config.productionTip = false;

new Vue({
    store,
    router,
    render: (h) => h(App)
}).$mount('#app');
